import { useRef } from 'react';
import { OS } from 'components/app/_mediator/app.slice';
import { ZOOM_STEP } from './_pan-zoom.params';

export const usePanZoomStep = (os: OS) => {
  const prevDate = useRef(0);

  const getInterval = () => {
    const now = Date.now();
    const interval = now - prevDate.current;
    prevDate.current = now;
    return interval;
  };

  const getMacStep = (e: React.WheelEvent) => {
    return e.deltaY / 100 / 22;
  };

  const getWinStep = (e: React.WheelEvent) => {
    const interval = getInterval();
    let factor = 1;
    if (interval < 10) factor = 8;
    else if (interval < 30) factor = 6;
    else if (interval < 50) factor = 4;
    const step = ZOOM_STEP * factor;
    return e.deltaY < 0 ? -1 * step : step;
  };

  return os === 'mac' ? getMacStep : getWinStep;
};
